<script>
    import {setContext, onMount} from 'svelte';
    import UsersPlayers from './UsersPlayers.svelte';
    import PlayerGroup from './PlayerGroup.svelte';

    export let _players;
    export let _headcoach;
    export let bidInfo;
    export let biddingInfo;
    export let bidState;
    export let BID_STATE_CONST;
    export let auctionPlayer;
    export let ws;
    export let startTime;
    export let targetTime;
    export let clientPosition;
    export let disconnectedPosition;


    export let gameAlert = function(msg) {
        alert(msg);
    };
    export let publishTestMode = false;

    let state_text = '경매중'    
    let _playersClone = deepClone(_players);

    function deepClone(obj, hash = new WeakMap()) {
        if (Object(obj) !== obj) return obj; // primitives
        if (hash.has(obj)) return hash.get(obj); // cyclic reference
        const result = obj instanceof Set ? new Set(obj) // See note about this!
                    : obj instanceof Map ? new Map(Array.from(obj, ([key, val]) => 
                                            [key, deepClone(val, hash)])) 
                    : obj instanceof Date ? new Date(obj)
                    : obj instanceof RegExp ? new RegExp(obj.source, obj.flags)
                    // ... add here any specific treatment for other classes ...
                    // and finally a catch-all:
                    : obj.constructor ? new obj.constructor() 
                    : Object.create(null);
        hash.set(obj, result);
        return Object.assign(result, ...Object.keys(obj).map(
            key => ({ [key]: deepClone(obj[key], hash) }) ));
    }
    let bid_done_sound;
    let bid_fail_sound;
    let timer_sound;
    
	
    $: {
        switch (bidState) {
            case BID_STATE_CONST.READY:
                // messageInput(`입찰 선수를 준비중입니다.`);
                target.setCurrentPlayer();
                target = target;
                state_text = `경매 준비중`;
                messageInput('경매 준비');
                stopSound(bid_done_sound);
                stopSound(bid_fail_sound);
                break;
            case BID_STATE_CONST.FORCE_READY:
                state_text = `경매 준비중`;
                messageInput('경매 준비');
                stopSound(bid_done_sound);
                stopSound(bid_fail_sound);
                break;
            case BID_STATE_CONST.ON_RECEIVE:
                messageInput(`경매가 시작되었습니다.`);
                state_text = `경매 진행중`;

                timer_sound.play();
                timer_sound.loop = true;
                
                break;
            case BID_STATE_CONST.ON_BIDDING:
                // console.log('on_bid');
                bid.setCurrentBidder(biddingInfo);
                state_text = `${currentBidder} - ${bidCost} 입찰중`;
                break;
            case BID_STATE_CONST.SUCCESS:
                user.syncUsersData();
                bid.setCurrentBidder(bidInfo);
                timer.ratio = 0;
                state_text = `낙찰 - ${currentBidder} ${bidCost}`;
                bid.bidCompleate();
                stopSound(timer_sound);
                break;
            case BID_STATE_CONST.FORCE_BID:
                console.log('bid_force');
                timer.ratio = 0;
                state_text = `남은 자리 강제 배정`;
                messageInput(`강제 배정되었습니다`);
                user.syncUsersData();
                bid.bidCompleate(true);
                stopSound(timer_sound);
                break;
            case BID_STATE_CONST.FAIL:
                user.syncUsersData();
                // console.log('fail');
                timer.ratio = 0;
                state_text = `유찰`;
                bid.bidFail();
                stopSound(timer_sound);
                break;
            case BID_STATE_CONST.END:
                timer.ratio = 0;
                state_text = `경매 종료`;
                messageInput(`경매 종료`);
                stopSound(timer_sound);
                break;
          
        }
        notSelectedGroup = notSelectedGroup;
        _players = _players;
        target = target;
        bidInfo = bidInfo;
        biddingInfo = biddingInfo;
        users = users;
 
    }
    const stopSound = function(obj) {
        if (obj) {
            obj.pause();
            obj.currentTime = 0;
        }
    }
    const playSound = function(obj) {
        if (obj) {
            obj.play();
        }
    }
    //메세지 박스
    let msg = '';
    let messageInput = function(message) {
        msg = message;
    }
    let positionInfo =  {
        position_order: [ 'top', 'jungle', 'mid', 'adc', 'support'],
        position_kor: {  top: '탑', jungle: '정글', mid: '미드', adc: '원딜', support: '서폿' },
        position_bg: {  
            top : 'https://static.inven.co.kr/image_2011/enchantenter/220509/icon-team-position-top.png',
            jungle: 'https://static.inven.co.kr/image_2011/enchantenter/220509/icon-team-position-jg.png?v=220512a',
            mid: 'https://static.inven.co.kr/image_2011/enchantenter/220509/icon-team-position-mid.png',
            adc: 'https://static.inven.co.kr/image_2011/enchantenter/220509/icon-team-position-adc.png',
            support: 'https://static.inven.co.kr/image_2011/enchantenter/220509/icon-team-position-supp.png'
        },
        position_simple: {
            top: 'TOP', jungle: 'JGL', mid: 'MID', adc: 'BOT', support: 'SUP'
        },
    }
    let rank_kor = {
        iron: '아이언', bronze : '브론즈', silver: '실버', gold: '골드', platinum: '플래티넘', diamond: '다이아', challenger: '챌린저'
    }
    let rank_alias = {
        iron: 'tier-i', bronze: 'tier-b', silver: 'tier-s', gold: 'tier-g',  platinum: 'tier-p', diamond: 'tier-d', challenger: 'tier-c'
    }

    let users = [
        {point: 1000, players: {top:{},jungle:{},mid:{},adc:{}, support: {} } },
        {point: 1000, players: {top:{},jungle:{},mid:{},adc:{}, support: {} } },
        {point: 1000, players: {top:{},jungle:{},mid:{},adc:{}, support: {} } },
        {point: 1000, players: {top:{},jungle:{},mid:{},adc:{}, support: {} } },
        {point: 1000, players: {top:{},jungle:{},mid:{},adc:{}, support: {} } },
        {point: 1000, players: {top:{},jungle:{},mid:{},adc:{}, support: {} } },
    ]

  



    //유찰 그룹 
    let notSelectedGroup = [];
    //현재 입찰 중인 선수 객체 .
    let target = {
        currentPlayer: {},
        setCurrentPlayer: function() {
            bidCost = 0;
            if (publishTestMode) {
                return;
            }
            if (auctionPlayer) {
                let lane = auctionPlayer['lane'] 
                ,   index = +auctionPlayer['index'];
                if ( _playersClone[lane][index]) {
                    this.currentPlayer = deepClone(_playersClone[lane][index]);
                    this.currentPlayer.position = lane;
                    // messageInput(`현재 입찰 선수: ${this.currentPlayer.name}`);
                }
            }
        },
        removeCurrentTarget: function(bid_force = false) {
            let lane = auctionPlayer['lane'] 
            ,   index = +auctionPlayer['index'];
            if (!bid_force) {
                if (_players[lane][index]) {
                    delete _players[lane][index];
                }
            }else {
                //강제 배정시에는 현재 입찰 플레이어가 없기때문에 낙찰 정보 기준으로 삭제
                delete _players[bidInfo.player.lane][bidInfo.player.index];
            }
        },
    }
   
  
    let timer = {
        ratio: 0,
        timer: null,
        timeLeft: 0,
        clearTimer: function() {
            if (!timer.timer) clearTimeout(this.timer);
        },
        setTimerProgress: function() {
            this.clearTimer();  
            timer.timer = setInterval(() => {
                timer.timeLeft = targetTime - ((Date.now() - startTime)/1000).toFixed(0);
                if (timer.timeLeft < 0) timer.timeLeft = 0;
                timer.ratio = ((((Date.now() - startTime)/1000).toFixed(1)/targetTime)*100).toFixed(2);
                if (timer.ratio > 100) timer.ratio = 100;
            }, 100)   
        },
        initTimer: function() {
            this.ratio = 0;
            this.timer = null;
            this.timeLeft = 0;
        }

    }


    /*유저 그룹은 내 정보가 최우선, 나머지는 감독명 가나다순 정렬
    * ㄴ 유저 그룹 객체를 재배열
    * ㄴ 정렬된 감독 정보에는 각각의 유저를 알 수 있는 포지션 정보가 있다.
    */
    let user = {
        clientPosition: null,
        sortedHeadCoach: [],
        //내 유저 정보를 가져옴
        getMyUserData: function() {
            for (let i in users) {
                if (i == this.clientPosition) {
                    return users[i];
                }
            }
        },
        //클라이언트 아이디 지정
        setUserData: function() {
            this.clientPosition = clientPosition;
            messageInput(`당신은 ${_headcoach[this.clientPosition].name} 입니다.`);
        },
        //경매 스테이트에 따라 유저 데이터를 업데이트함
        syncUsersData: function() {
            
            if (bidInfo.director !== -1) {
                if (bidInfo.info.directors) {
                    for(let drIndex in bidInfo.info.directors) {
                        users[drIndex].point = bidInfo.info.directors[drIndex].point;
                    }
                }
                if (bidInfo.player) {
                    users[bidInfo.director].players[bidInfo.player.lane] = bidInfo.player;
                    users[bidInfo.director].players[bidInfo.player.lane].point = bidInfo.point;
                }
                
            }
            if (bidInfo.info.bid_failure) {
                notSelectedGroup = bidInfo.info.bid_failure;
            }
            
        },
        //나의 감독 정보를 가져옴
        getMyHeadCoachInfo: function() {
            return _headcoach[this.clientPosition];
        },
        //감독 정보를 가져옴
        getHeadCoachInfo: function(clientPosition) {
            return _headcoach[clientPosition];
        },
        //감독 데이터를 재배열
        sortHeadCoach: function() {
            for(let coach_index in _headcoach) {
                for (let i in users) {
                    if (i == coach_index) {
                        _headcoach[coach_index].user_position = i;
                    }
                }
            }
           
            this.sortedHeadCoach = Object.values(_headcoach);
            this.sortedHeadCoach.sort((a,b) => {
                if (a.name < b.name) {
                    return -1 
                }else if (a.name == b.name) {
                    return 0
                }else { 
                    return 1 
                }
            });
        
            for (let ind in this.sortedHeadCoach) {
                if (this.sortedHeadCoach[ind].name == this.getMyHeadCoachInfo().name) {
                    this.sortedHeadCoach.splice(ind, 1);
                    break;
                }
            }
            
            this.sortedHeadCoach.unshift(this.getMyHeadCoachInfo());
            
        },
        //경매 포지션 선수를 이미 소유하고 있는지 체크 
        hasPlayer : function() {
            // console.log(users, this.clientPosition);
            if (users[this.clientPosition].players[auctionPlayer.lane] && Object.keys(users[this.clientPosition].players[auctionPlayer.lane]).length >0) {
                return true;
            } else {
                return false;
            }
        },
        //초기 함수 시작
        init: function() {
            this.setUserData();
            this.sortHeadCoach();
        }
    }

    /**
     * 경매 입찰/낙찰/유찰
     * 
     */ 
    let bidCost = biddingInfo.point;
    let typedCost='';
    let currentBidder = '';
    let bid = { 
        bidTimer: null,
        //입찰
        onBidding: function(increment, plus) {   
            if (increment >= 0) { 
                if (user.hasPlayer()) { 
                    bidCost = biddingInfo.point ?biddingInfo.point: 0;
                    return gameAlert(`이미 보유한 포지션입니다.`);
                }
                if (biddingInfo.director == user.clientPosition) {
                    bidCost = biddingInfo.point ?biddingInfo.point: 0;
                    return gameAlert('이미 최대 입찰자로 참여 중입니다.');
                }
                if (!plus) {
                    if (increment > bidCost) {
                        bidCost = increment;
                    }else if (increment <= bidCost) {
                        console.log(increment, bidCost);
                        return gameAlert('입찰 금액보다 큰 금액을 입력하여 주세요.');
                    }
                }else {
                    bidCost = +bidCost + increment;
                }
                if (bidCost > 0) {
                    if(bidCost > users[user.clientPosition].point) {
                        bidCost = biddingInfo.point ?biddingInfo.point: 0;
                        return gameAlert('가지고 있는 금액보다 큰 금액입니다.');
                    }
                    ws.socket.bidding(bidCost);                 
                }
            
            }else {
                return gameAlert('0보다 큰 수를 입력 해 주세요.');
            }
        },
        //낙찰 됨 
        bidCompleate: function(bid_force = false) {
            target.removeCurrentTarget(bid_force);
            if (!bid_force && currentBidder){
                let msg = `<span class='gold'>${currentBidder}</span><span>|</span><span class='gold'>${bidCost}</span>`;
                // let msg2 =  `${currentBidder} 감독 ${target.currentPlayer.name} - 낙찰`;
                currentBidder = '';
                messageInput(msg);
                //return gameAlert(msg2);
            }else {
                let msg = `<span class='gold'>${user.getHeadCoachInfo(bidInfo.director).name}</span><span>|</span><span class='gold'>자동 낙찰</span>`;
                messageInput(msg);
            }
            // console.log(bid_done_sound);
            playSound(bid_done_sound)
            typedCost = '';
        },
        //유찰
        bidFail: function() {
            target.removeCurrentTarget();
            currentBidder = '';
            let msg = `유찰`;
            messageInput(msg);
            playSound(bid_fail_sound)
            typedCost = '';
            //return gameAlert(msg);
        },
        //5단위 체크
        validateSummit: function(increment = 0, plus = true) {
            if(bidState == BID_STATE_CONST.READY) {
                return gameAlert(`경매 시작 전 입니다.`);
            }
            if (bidCost%5 != 0) {
                return gameAlert('입찰은 5단위로만 입력 가능합니다.'); 
            }
            if(bidState == BID_STATE_CONST.ON_BIDDING) {
                this.bidTimer = setTimeout(() => {
                    bid.onBidding(increment, plus);
                    clearTimeout(bid.bidTimer);
                },500);
            }else {
               this.onBidding(increment, plus); 
            }
          
        },
        add: function(inc) {
            typedCost = +inc+bidCost;
        },
        setCurrentBidder: function(info) {
            currentBidder =  user.getHeadCoachInfo(info.director).name;
            bidCost = info.point;
            messageInput(`<span>${currentBidder}</span><span>|</span><span>${bidCost}</span>`);
        }
    }
   

    user.init();
    timer.setTimerProgress();
    // target.setCurrentPlayer();
    setContext('positionInfo', positionInfo); 
    setContext('rank_alias', rank_alias);
    onMount(() => {
        bid_done_sound = document.getElementById("bid_done");
        bid_fail_sound = document.getElementById("bid_fail");
        timer_sound =  document.getElementById("bid_timer");
        console.log(bid_done_sound);
        bid_done_sound.load();
        bid_fail_sound.load();
        timer_sound.load();
    })
</script>

<!-- S : PAGE[3] - 게임판 -->
<div class="info-box">
    <audio id="bid_done" src="https://static.inven.co.kr/image_2011/enchantenter/bid_done.mp3"></audio>
    <audio id="bid_fail" src="https://static.inven.co.kr/image_2011/enchantenter/bid_fail.mp3"></audio>
    <audio id="bid_timer" src="https://static.inven.co.kr/image_2011/enchantenter/timer.mp3"></audio>
    <div class="group info" data-tier="tier-{target.currentPlayer.rank}">
        <div class="img tier"><img src="//upload3.inven.co.kr/upload/{target?.currentPlayer?.image?.small}"
                              alt="{target.currentPlayer.name}" width="161" height="161"></div>
        <div class="txt-box">
            <p class="name">
                <span class="position-txt">{positionInfo.position_kor[target.currentPlayer.position]}</span>
                <span class="tier-text">{rank_kor[target.currentPlayer.rank]}</span>
            </p>
            <p class="player-name">{target.currentPlayer.name}</p>
        </div>
    </div>
    <div class="group score">
        <div class="score-info">
            {@html msg}
        </div>
        <div class="gauge" class:me={currentBidder && currentBidder === user.getMyHeadCoachInfo()?.name}><span class="num" style="width:{timer.ratio}%;"></span><span class="text">{@html state_text} | {timer.timeLeft}초</span></div>
    </div>
</div>
<div class="score-info">
    <div class="input-box">
        <div class="input-enter">
            <input type="text" pattern="[0-9]" placeholder="5-1000까지의 정수를 입력해주세요" bind:value="{typedCost}" min="5" max="1000"
                   on:keyup={(e,) => { if (e.key == 'Enter') bid.validateSummit(+typedCost, false);}}>
            <!-- <div class="num">{bidCost}</div> -->
        </div>
        <div class="btn-wrap">
            <button type="button" class="btn submit" on:click={() => { bid.validateSummit(+typedCost, false);}}>입찰
            </button>
        </div>
    </div>
    <div class="btn-wrap">
        <button type="button" class="btn" on:click={() => { bid.add(5)}}>+5</button>
        <button type="button" class="btn" on:click={() => { bid.add(10);}}>+10</button>
        <button type="button" class="btn" on:click={() => { bid.add(50);}}>+50</button>
        <button type="button" class="btn" on:click={() => { bid.add(100);}}>+100</button>
    </div>
</div>
<div class="game-result">
    <div class="large-group">
    {#each user.sortedHeadCoach as coach, id }
        {#if id < 3}  
        <div class="group">
            <div class="team-info">
                <p class="name">{coach.name} 팀</p>
                <div class="point-box">
                    {#if id == 0}
                    <div class="team">내팀</div>
                    {/if}
                    <p class="point">포인트 <span class="num">{users[coach.user_position].point}</span></p>
                </div>
            </div>
            <ul class="team-list" data-user-position={coach.user_position}>
                <li class="item">
                    <div class="team director">
                        <span class="img"><img
                                src="//upload3.inven.co.kr/upload/{coach.image}" alt=""
                                width="68" height="69"></span>
                        <span class="name">{coach.name}</span>
                    </div>
                </li>
               <UsersPlayers users={users} coach={coach} _playersClone={_playersClone} />
            </ul>
        </div>
        {/if}
    {/each}
    </div>
    <div class="large-group">
    {#each user.sortedHeadCoach as coach, id }
        {#if id > 2}  
        <div class="group">
            <div class="team-info">
                <p class="name">{coach.name} 팀</p>
                <div class="point-box">
                    <p class="point">포인트 <span class="num">{users[coach.user_position].point}</span></p>
                </div>
            </div>
            <ul class="team-list">
                <li class="item">
                    <div class="team director">
                        <span class="img"><img
                                src="//upload3.inven.co.kr/upload/{coach.image}" alt=""
                                width="68" height="69"></span>
                        <span class="name">{coach.name}</span>
                    </div>
                </li>
               <UsersPlayers users={users} coach={coach}  _playersClone={_playersClone} />
            </ul>
        </div>
        {/if}
    {/each}
    </div>
</div>
<div class="game-result fold">
    <button type="button" class="btn-fold" on:click={(e) => {e.target.classList.toggle('on');}}>대기선수</button>
    <div class="fold-wrap">
        <div class="large-group">
            <div class="tier-group bidding">
                <div class="tier">유찰</div>
                <div class="list-box">
                    <div class="info">유찰 순서<br>▶▶▶</div>
                    <ul class="team-list">
                        {#each notSelectedGroup as player}
                            <li class="item" data-tier={rank_alias[_playersClone[player.lane][player.index].rank]}>
                                <button type="button" class="team">
                                <span class="img"><img
                                        src="//upload3.inven.co.kr/upload/{_playersClone[player.lane][player.index].image.small}"
                                        alt="" width="68" height="69"></span>
                                    <span class="name">{_playersClone[player.lane][player.index].name}</span>
                                </button>
                            </li>
                        {/each}
                    </ul>
                </div>
            </div>
            <div class="tier-group">
                <div class="tier">TOP</div>
                <ul class="team-list">
                    <PlayerGroup bind:_players defaultPos={'top'}  />
                </ul>
            </div>
            <div class="tier-group">
                <div class="tier">JGL</div>
                <ul class="team-list">
                    <PlayerGroup bind:_players defaultPos={'jungle'} />
                </ul>
            </div>
        </div>
        <div class="large-group">
            <div class="tier-group">
                <div class="tier">MID</div>
                <ul class="team-list">
                    <PlayerGroup bind:_players defaultPos={'mid'} />
                </ul>
            </div>
            <div class="tier-group">
                <div class="tier">BOT</div>
                <ul class="team-list">
                   <PlayerGroup bind:_players defaultPos={'adc'} />
                </ul>
            </div>
            <div class="tier-group">
                <div class="tier">SUP</div>
                <ul class="team-list">
                    <PlayerGroup bind:_players defaultPos={'support'} />
                </ul>
            </div>
        </div>
    </div>
   
</div>
<div class="game-info"><p class="supported-by">thanks to 레드다이어리</p></div>
<!-- E : PAGE[3] - 게임판 -->

<style lang="scss">
</style>